export const advertisersConstants = {
    GET_ADVERTISERS_REQUEST: 'GET_ADVERTISERS_REQUEST',
    GET_ADVERTISERS_SUCCESS: 'GET_ADVERTISERS_SUCCESS',
    GET_ADVERTISERS_FAILURE: 'GET_ADVERTISERS_FAILURE',
    GET_ADVERTISERS_URL_REQUEST_BULK: 'GET_ADVERTISERS_URL_REQUEST_BULK',
    GET_ADVERTISERS_URL_REQUEST: 'GET_ADVERTISERS_URL_REQUEST',
    GET_ADVERTISERS_URL_SUCCESS: 'GET_ADVERTISERS_URL_SUCCESS',
    GET_ADVERTISERS_URL_FAILURE: 'GET_ADVERTISERS_URL_FAILURE'
}